import React from 'react';
import { IMAGE_URL } from '@ordermentum/ui-constants';

const StandaloneFooter = () => (
  <footer className="flex items-center justify-center gap-x-xs border border-solid border-background-subtle py-l">
    <p className="font-body text-body-small text-subtle">Powered by</p>
    <img
      className="h-6"
      src={`${IMAGE_URL}/logo-ordermentum-full.svg`}
      alt="Ordermentum"
    />
  </footer>
);

export default StandaloneFooter;
